import type { StatementPrompt } from "./components.interface";

const None = (()=>()=> "") satisfies StatementPrompt;

export {
    None
}